import React, { PropTypes } from 'react';
import CircularProgress from 'material-ui/CircularProgress';
import FlatButton from 'material-ui/FlatButton';
import { debounce } from '../utilites/func';

class LoadMore extends React.Component {
  static propTypes = {
    pageBottomOffset: PropTypes.number.isRequired,
    active: PropTypes.bool.isRequired,
    loadMore: PropTypes.func.isRequired
  };

  static contextTypes = {
    containerElement: PropTypes.object,
    containerContent: PropTypes.element
  };

  state = {
    needCheckScroll: true
  };

  getContainerElement() {
    let { containerElement } = this.context || {};
    return containerElement || window;
  }

  getContainerContent() {
    let { containerContent } = this.context || {};
    return containerContent || document.body;
  }

  constructor() {
    super(...arguments);

    this.handleScroll = debounce(() => this._handleScroll(...arguments), 100);
    this.loadMore = () => this.props.loadMore();
  }

  componentDidMount() {
    this.getContainerElement().addEventListener('scroll', this.handleScroll);
  }

  componentWillUnmount() {
    this.getContainerElement().removeEventListener('scroll', this.handleScroll);
  }

  _handleScroll() {
    let { pageBottomOffset, loadMore, active } = this.props;

    if (
      active && this.state.needCheckScroll
      && this.getContentHeight() - this.getVisibleHeight() > 0
      && (this.getContentHeight() - this.getVisibleHeight()) - this.getScrollHeight() < pageBottomOffset
    ) {
      this.setState({needCheckScroll: false});
      Promise.resolve(loadMore())
        .then(() => this.setState({needCheckScroll: true}))
    }
  }

  getScrollHeight() {
    return this.getContainerElement().pageYOffset;
  }

  getVisibleHeight() {
    return this.getContainerElement().innerHeight;
  }

  getContentHeight() {
    return this.getContainerContent().offsetHeight
  }

  render() {
    let { active } = this.props;
    let { needCheckScroll } = this.state;
    return (
      <div>
        {this.props.children}
        <div style={{textAlign: 'center', height: 36, display: active ? 'block' : 'none'}}>
        { !needCheckScroll
          ? (<CircularProgress size={60} />)
          : (<FlatButton primary={true} onClick={this.loadMore}>Load more</FlatButton>) }
        </div>

      </div>
    );
  }
}

LoadMore.defaultProps = {
  active: false,
  pageBottomOffset: 100
};

export default LoadMore;




// WEBPACK FOOTER //
// ./src/components/LoadMore.jsx